import { trackEvent } from "@/lib/audit";
import type { MatchRewardSummary } from "@/lib/pr25/postMatchSummary";

const KEY = "ss2026_post_match_recap_v1";

export function storeRecap(summary: MatchRewardSummary) {
  if (typeof window === "undefined") return;
  try { localStorage.setItem(KEY, JSON.stringify({ summary, saved_at: new Date().toISOString() })); }
  catch { /* noop */ }
}

export function getStoredRecap(): { summary: MatchRewardSummary; saved_at: string } | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function reopenStoredRecap() {
  const r = getStoredRecap();
  if (!r) return;
  void trackEvent("post_match_recap_reopened", { match_id: r.summary.match_id });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("ss2026:post-match-summary", { detail: r.summary }));
  }
}